module.exports = __webpack_public_path__ + "static/media/display-tray-exterior.cb7c860a.png";